export default __webpack_public_path__ + "static/media/HumanIcon.c6fd1267.svg";